<template>
  <div class="app-header">
    <div class="header-container">
      <div class="logo">
        <router-link to="/">
          <span class="logo-text">{{ $t('app.header.logo') }}</span>
        </router-link>
      </div>
      <el-menu mode="horizontal" :router="true" class="main-menu" :default-active="activeMenu">
        <!-- <el-submenu index="1">
          <template slot="title">{{ $t('app.header.storeSim') }}</template>
          <el-menu-item index="/products/type/country">{{ $t('app.header.byCountry') }}</el-menu-item>
          <el-menu-item index="/products/type/device">{{ $t('app.header.byDevice') }}</el-menu-item>
        </el-submenu> -->
        <el-menu-item index="/products/esim">{{ $t('app.header.esim') }}</el-menu-item>
        <el-menu-item index="/products/sim">{{ $t('app.header.sim') }}</el-menu-item>
        <el-menu-item index="/business">{{ $t('app.header.business') }}</el-menu-item>
        <el-menu-item index="/support">{{ $t('app.header.support') }}</el-menu-item>
      </el-menu>
      <div class="header-right">
        <el-dropdown trigger="click" @command="handleLanguageChange">
          <span class="el-dropdown-link">
            {{ $t(`languages.${currentLanguage}`) }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh">{{ $t('languages.zh') }}</el-dropdown-item>
            <el-dropdown-item command="en">{{ $t('languages.en') }}</el-dropdown-item>
            <el-dropdown-item command="ja">{{ $t('languages.ja') }}</el-dropdown-item>
            <el-dropdown-item command="fr">{{ $t('languages.fr') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleCurrencyChange">
          <span class="el-dropdown-link">
            {{ currentCurrency }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="USD">USD</el-dropdown-item>
            <el-dropdown-item command="EUR">EUR</el-dropdown-item>
            <el-dropdown-item command="CNY">CNY</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        
        <!-- 用户菜单 -->
        <template v-if="isAuthenticated">
          <el-dropdown trigger="click" @command="handleUserCommand">
            <span class="el-dropdown-link">
              {{ user.email }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">{{ $t('app.header.profile') }}</el-dropdown-item>
              <!-- <el-dropdown-item command="orders">{{ $t('app.header.orders') }}</el-dropdown-item>
              <el-dropdown-item command="settings">{{ $t('app.header.settings') }}</el-dropdown-item> -->
              <el-dropdown-item divided command="logout">{{ $t('app.header.logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <el-button type="text" @click="showLoginForm = true">
            {{ $t('app.header.login') }}
          </el-button>
        </template>

        <!-- <el-badge :value="cartItemCount" class="cart-badge">
          <el-button type="text" @click="showCart = true">
            <i class="el-icon-shopping-cart-2"></i>{{ $t('app.header.cart') }}
          </el-button>
        </el-badge> -->
      </div>
    </div>

    <!-- 购物车抽屉-->
    <cart-drawer :visible.sync="showCart" />

    <!-- 登录表单 -->
    <login-form 
      :visible.sync="showLoginForm"
      @show-register="showLoginForm = false; showRegisterForm = true"
    />

    <!-- 注册表单 -->
    <register-form 
      :visible.sync="showRegisterForm"
      @show-login="showRegisterForm = false; showLoginForm = true"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CartDrawer from '@/components/cart/CartDrawer.vue'
import LoginForm from '@/components/auth/LoginForm.vue'
import RegisterForm from '@/components/auth/RegisterForm.vue'

export default {
  name: 'AppHeader',
  components: {
    CartDrawer,
    LoginForm,
    RegisterForm
  },
  data() {
    return {
      showCart: false,
      showLoginForm: false,
      showRegisterForm: false
    }
  },
  computed: {
    ...mapGetters(['cartItemCount', 'isAuthenticated']),
    ...mapState({
      currentLanguage: state => state.language,
      currentCurrency: state => state.currency,
      user: state => state.user
    }),
    languageLabel() {
      return this.currentLanguage === 'zh' ? '简体中文' : 'English'
    },
    activeMenu() {
      return this.$route.meta.activeMenu || this.$route.path;
    }
  },
  methods: {
    handleLanguageChange(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('updateLanguage', lang)
    },
    handleCurrencyChange(currency) {
      this.$store.dispatch('updateCurrency', currency)
    },
    async handleUserCommand(command) {
      switch (command) {
        case 'profile':
          this.$router.push({path: '/user/profile', query: {userId: this.user.userId, email: this.user.email}})
          break
        case 'orders':
          this.$router.push('/user/orders')
          break
        case 'settings':
          this.$router.push('/user/settings')
          break
        case 'logout':
          try {
            await this.$store.dispatch('logout')
            this.$message({
              type: 'success',
              message: '已成功退出登录'
            })
            if (this.$route.path !== '/') {
              this.$router.push('/')
            }
          } catch (error) {
            this.$message.error('退出登录失败，请重试')
          }
          break
      }
    }
  },
  created() {
    // 初始化store
    this.$store.dispatch('initializeStore')

  }
}
</script>

<style lang="less" scoped>
.app-header {
  width: 100%;
  .header-container {
    max-width: 1500px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
  }

  .logo {
    img {
      height: 40px;
    }
  }

  .main-menu {
    flex: 2;
    margin: 0 20px;
    border-bottom: none;
    
    :deep(.el-menu-item),
    :deep(.el-submenu__title) {
      font-size: 16px;
      font-weight: 600;

      // text-transform: uppercase;//字母转大写
      letter-spacing: 0.5px;
      height: 80px;
      line-height: 80px;
      max-width: 250px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;

    .el-dropdown-link {
      cursor: pointer;
      color: #409EFF;
      font-weight: 600;
      font-size: 15px;
      // text-transform: uppercase;
    }

    .cart-badge {
      margin-left: 20px;
    }
  }
}

.logo-text {
  font-size: 28px;
  font-weight: 800;
  color: #00c853;
  text-decoration: none;
  letter-spacing: 2px;
  font-family: 'Arial Black', Arial, sans-serif;
  // text-transform: uppercase;
}

.logo a {
  text-decoration: none;
}

@media (max-width: 768px) {
  .app-header {
    .header-container {
      padding: 0 15px;
    }

    .logo-text {
      font-size: 24px;
    }

    .main-menu {
      margin: 0 20px;
      
      :deep(.el-menu-item),
      :deep(.el-submenu__title) {
        font-size: 14px;
      }
    }

    .header-right {
      gap: 10px;

      .el-dropdown-link {
        font-size: 14px;
      }
    }
  }
}
</style> 
